import script from "./Page15.vue?vue&type=script&setup=true&lang=js"
export * from "./Page15.vue?vue&type=script&setup=true&lang=js"

import "./Page15.vue?vue&type=style&index=0&id=6bd74c28&lang=less"

const __exports__ = script;

export default __exports__